import { computed, observable } from 'mobx'
import { func } from 'validx'
import { serializable, serialize, snapshotable } from '../data/serialization'
import { receiveErrors } from '../data/serverErrors'
import { Types } from '../data/Type'
import { validatable } from '../mixins/validation'
import RynoEditor from '../ryno-editor/RynoEditor'

const LIST_OF_STRING = Types.list(Types.string)

/**
 * Specs config editor.
 */
@snapshotable
@validatable({ liveValidation: true })
export default class SpecsConfigEditor {
  @observable
  @serializable
  expr

  rules = {
    expr: [func((ctx) => ctx.value.analyze(), 'There are formula errors.')],
  }

  constructor(legendEditor) {
    this.legendEditor = legendEditor
    this.expr = new RynoEditor({
      getSymbolTable: () => this.symbolTable,
      getNeededType: () => LIST_OF_STRING,
    })
  }

  @computed
  get symbolTable() {
    return this.legendEditor.getSymbolTableFor(this)
  }

  hydrate(specsConfig) {
    this.expr.setValue(specsConfig?.expr ?? '', true)
  }

  toJSON() {
    return serialize(this)
  }

  receiveErrors(descriptor = {}) {
    const { inner = {} } = descriptor
    receiveErrors(this, inner)
  }
}
